<style>
#addVideoInspectionCardModal .v--modal-box.v--modal {
  min-height: 500px !important;
  min-width: 680px !important;
}
#addVideoInspectionCardModal #attr__wrapper .layout:not(#geometry-panel) {
  margin-top: 20px;
}
#addVideoInspectionCardModal .v-tabs__div:not(:last-child) {
  padding-right: 10px;
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#addVideoInspectionCardModal .v-select__selection,
#addVideoInspectionCardModal .v-select__slot input {
  font-size: 12px !important;
}
.table__btn--green.btn-process-attachments,
.table__btn--red.btn-process-attachments {
  display: none !important;
}
.tab--active {
  background: rgba(255, 255, 255, 1);
  color: rgba(42, 87, 154, 1);
}
.geometry-panel {
  background-color: #f5f5f5;
  height: 50px;
  line-height: 50px;
}
.geometry-panel__add-btn,
.geometry-panel__delete-btn,
.geometry-panel__zoom-btn {
  line-height: 16px;
  padding-right: 10px;
  padding-left: 10px;
}
.geometry-panel__zoom-btn {
  padding-right: 10px;
}
.msg--padding {
  padding-left: 10px;
}
.msg--no-data {
  text-align: center;
  margin-top: 50px;
}
.hover__pointer:hover {
  cursor: pointer;
}
</style>

<template>
  <Modal
    modalName="addVideoInspectionCardModal"
    title="DODAJ INSPEKCJĘ WIDEO"
    :buttons="['save']"
    :module="module"
    @opened="loadDict()"
    @saved="saveVideoInspection()"
    @closed="close()"
    :isNewObject="isNewInspection"
    :hideButtons__right="!isNewInspection"
  >
    <div>
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card
            flat
            id="attr__wrapper"
          >
            <v-layout
              row
              wrap
              class="geometry-panel"
            >
              <v-flex
                xs4
                v-if="!inspectionGeom"
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              >
                <v-icon
                  class="table__btn--green geometry-panel__add-btn"
                  @click="addGeometry"
                >add_circle</v-icon>
                <p
                  @click="addGeometry"
                  class="hover__pointer"
                >Dodaj geometrię</p>
              </v-flex>
              <v-flex
                xs4
                v-else
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              >
                <v-icon class="table__btn--red geometry-panel__delete-btn">delete</v-icon>
                <p
                  class="hover__pointer"
                  @click="removeGeometry"
                >Usuń geometrię</p>
              </v-flex>
              <v-flex xs8>
                <v-layout
                  justify-space-between
                  id="geometry-panel"
                >
                  <p
                    v-if="inspectionGeom"
                    class="msg--padding"
                  >Geometria dodana</p>
                  <p
                    v-else
                    class="msg--padding"
                  >Brak dodanej geometrii</p>
                  <span v-if="inspectionGeom">
                    <v-icon
                      title="Przybliż do geometrii"
                      class="geometry-panel__zoom-btn"
                      @click="zoomToInspectionGeom"
                    >zoom_in</v-icon>
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrawp
            >
              <v-flex xs5>
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      label="Data inspekcji"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                    color="#2a579a"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="inspection_typeDict"
                  v-model="inspectionType"
                  label="Typ inspekcji"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-autocomplete
                  v-model="inspectionAddress"
                  :items="addressItems"
                  :search-input.sync="search"
                  cache-items
                  label="Adres"
                  no-data-text="Rozpocznij wprowadzanie adresu"
                ></v-autocomplete>
              </v-flex>
              <v-spacer/>
            </v-layout>

            <v-layout
              row
              wrawp
            >
              <v-flex xs12>
                <v-textarea
                  name="description"
                  label="Opis inspekcji wraz ze wskazaniem lokalizacji pliku"
                  v-model="description"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-select
                  :items="users"
                  item-text="name"
                  item-value="id"
                  no-data-text="Brak użytkowników"
                  v-model="inspectorID"
                  label="Identyfikator/nazwa inspektora wykonującego inspekcję"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-tab-item>

        <!-- No events during adding insepction - that's why (0) -->
        <v-tab>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text class="msg--no-data">Brak dostępnych zdarzeń</v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab>ZAŁĄCZNIKI (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text class="msg--no-data">Dodawanie załączników jest dostępne po zapisie inspekcji</v-card-text>
            <!-- <AddAttachment
              ref="videoInspectAttach"
              @confDialogOpened="triggerDialogAttach"
              :id_="oid"
              :objectType="objectType"
              :objectTable="objectTable"
              :auto="false"
              :module="module"
            /> -->
          </v-card>
        </v-tab-item>
      </v-tabs>

    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import Modal from "../../../shared/Modal";
import moment from "moment";
import debounce from "lodash/debounce";
import _ from "lodash/wrapperLodash";

export default {
  components: {
    AddAttachment,
    Modal
  },
  data: vm => ({
    addressItems: [],
    attachmentsNumber: 0,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: undefined,
    dateMenu: false,
    description: undefined,
    inspection_typeDict: [],
    inspectionType: undefined,
    inspectorID: undefined,
    inspectionAddress: undefined,
    inspectionGeom: undefined,
    inspectionGeom4326: undefined,
    isDrawing: false,
    module: 'addAttachmentsToObjects',
    objectType: "video",
    objectTable: "video",
    oid: undefined,
    isNewInspection: true,
    net_type: undefined,
    search: null,
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date)
    },
    search (val) {
      val && val !== this.inspectionAddress && this.querySelections(val)
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    assignGeomToInspection(polygonData) {
      this.inspectionGeom = polygonData[0];
      this.inspectionGeom4326 = polygonData[1];
    },
    close() {
      this.removeGeometry();

      this.date = new Date().toISOString().substr(0, 10);
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
      this.dateMenu = false;
      this.description = undefined;
      this.inspection_typeDict = [];
      this.inspectionType = undefined;
      this.inspectorID = undefined;
      this.inspectionGeom = undefined;
      this.isDrawing = false;
      this.oid = undefined;

      this.objectType = "video";
      this.objectTable = "video";
    },
    formatDate(date) {
      if(!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    getDictValues(field, table, schema) {
      let payload = {
        schema: schema,
        table: table,
        column: field
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          this[field + "Dict"] = r.values;
        }
      });
    },
    loadDict() {
      if(this.users.length < 1) {
        this.$store.dispatch("getUsers");
      }

      const payloads = [
        {
          schema: "registry",
          table: this.objectType,
          column: "inspection_type"
        }

      ]
      payloads.forEach(payload => {
        this.getDictValues(payload.column, payload.table, payload.schema)
      })
    },
    parseDate(date) {
      if(!date) return null

      const [day, month, year] = date.split('-')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    removeGeometry() {
      this.$root.$emit('removeMapLayer')
      this.inspectionGeom = undefined;
    },
    saveVideoInspection() {
      let payload = {
        'geometry': this.inspectionGeom4326,
        'inspection_date': this.date,
        'inspection_type': this.inspectionType,
        'description': this.description,
        'inspector_id': this.inspectorID,
        'address': this.inspectionAddress
      }
      this.$store.dispatch("addVideoInspectionCard", payload)
        .then(r => {
          if(r.status == 200) {
            this.$root.$emit(
              "showSnackbar",
              "success",
              `Pomyślnie dodano inspekcję wideo o ID: ${r.data.inserted}`
            );
            this.oid = r.data.inserted;
            // this.$refs.videoInspectAttach.$refs.attachmentDropzone.processQueue();

            this.close();
            this.$modal.hide("addVideoInspectionCardModal");
            this.$root.$emit("edited_video_inspection");
          } else {
            this.$root.$emit(
              "showSnackbar",
              "red",
              `${r.data.message}`
            );
          }
        });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    querySelections: _.debounce(function (val) {
      const self = this;
      let payload = {
        table: 'address',
        term: val
      };
      this.$store.dispatch("getObject", payload).then(r => {
        self.addressItems = [];
        for(let el of r) {
          self.addressItems.push(el.label);
        }
      });
    }, 500),
    zoomToInspectionGeom() {
      this.$root.$emit('zoomToArea', [this.inspectionGeom.coordinates]);
    }
  },
  mounted() {
    // this.$root.$on("deletedAttachmentGlobal", this.updateList);
    this.$root.$on('newGeomAdded', this.assignGeomToInspection);
    this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10));
    moment.locale("pl");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/video/modals/AddVideoInspectionCard.vue